import { api, type Api } from "@api/bot-base-api-request";
import { useMutation } from "@tanstack/react-query";

const BOT_WALLET_GENERATE_QUERY_KEY = "bot-wallet-generate";

type BotWalletGenerateParams = {
  appPubKey: string;
  userId: string;
  chainId: number;
};

type BotWalletGenerateResponse = {
  newWallet: { address: string };
};

const postBotWalletGenerate = async (
  api: Api,
  params: BotWalletGenerateParams,
): Promise<BotWalletGenerateResponse> =>
  api.post("wallet/generate", { json: params }).json();

const useBotWalletGenerateMutation = () =>
  useMutation({
    mutationFn: async (params: BotWalletGenerateParams) =>
      postBotWalletGenerate(api, params),
    mutationKey: [BOT_WALLET_GENERATE_QUERY_KEY],
  });

export { useBotWalletGenerateMutation, BOT_WALLET_GENERATE_QUERY_KEY };
